{
  "cardsData": [
    {
      "id": 0,
      "icon": "hand-cash-icon.svg",
      "text": "Preço competitivo",
      "hoverText": "Eles podem gerar dor de cabeça, problemas de mastigação e doenças do coração."
    },
    {
      "id": 1,
      "icon": "icon-heart.png",
      "text": "Satisfação dos seus colaboradores",
      "hoverText": "Também pode afetar a auto-estima e causar até falta de confiança."
    },
    {
      "id": 2,
      "icon": "icon-financial.png",
      "text": "Descontos em farmácias",
      "hoverText": "E quando aparecem de repente, tornam-se um imprevisto financeiro."
    }
  ]
}
